// Bridge to ComponentLoadingStatus: notify the global loader that file filtering is done.
// Used both for empty-result short-circuit and after the first batch render.

import { translateKey } from './translate.js';

// Mark `filesFiltered` ready with a localized caption.
// captionKey: translation key (e.g. 'loader_stage_files_filtered_displayed').
// fallbackCaption: English caption used when translation system is missing.
// debugMode: '1' to surface detailed logs.
export function markFilesFilteredReady(captionKey, fallbackCaption, debugMode) {
    if (!window.ComponentLoadingStatus) return;
    try {
        const component = window.ComponentLoadingStatus.get
            ? window.ComponentLoadingStatus.get('filesFiltered')
            : null;
        if (!component || component.status !== 'loading') return;

        let caption = fallbackCaption;
        if (window.TranslationRegistry && typeof window.TranslationRegistry.translate === 'function') {
            caption = translateKey(captionKey);
        }

        window.ComponentLoadingStatus.update('filesFiltered', 'ready', caption);
        if (debugMode === '1') {
            console.log(`[LazyLoadManager] ✅ filesFiltered status updated to ready (${captionKey})`);
        }
    } catch (e) {
        if (debugMode === '1') {
            console.warn('[LazyLoadManager] Error updating filesFiltered status:', e);
        }
    }
}
